import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    assignCorporateUserApi,
    destroyDealership, getCorporateUsers,
    getAllDealerships,
    getDealership,
    getDealerships,
    getDealershipStaff,
    getDealershipUsers,
    storeDealership, updateDealershipApi,
} from '../../services/api/dealerships.api';
import RootState from "../states/root.state";

export const fetchDealerships = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'dealership/list',
  async (params, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getDealerships(token,params);
      return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching dealerships.");
        } else {
            return rejectWithValue('An error occurred while fetching dealerships.');
        }
    } 
  }
);

export const fetchAllDealerships = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'dealership/all',
  async (params, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getAllDealerships(token, params);
      return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching all dealerships.");
        } else {
            return rejectWithValue('An error occurred while fetching all dealerships.');
        }
    } 
  }
);

export const fetchDealership = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'dealership',
  async (id, {rejectWithValue, getState}) => {

    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getDealership(token, id);
      return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.error??error.response.data.message??"An error occurred while fetching dealership.");
        } else {
            return rejectWithValue('An error occurred while fetching dealership.');
        }
    } 
  }
);

export const fetchDealershipUsers = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
  'dealership/users',
  async (getInfo, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getDealershipUsers(token, getInfo);
      return response.data;

    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching dealership users.");
        } else {
            return rejectWithValue('An error occurred while fetching dealership users.');
        }
    } 
  }
);

export const fetchDealershipStaff = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
  'dealership/staff',
  async (getInfo, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getDealershipStaff(token, getInfo);
      return response.data;

    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching dealership staff.");
        } else {
            return rejectWithValue('An error occurred while fetching dealership staff.');
        }
    } 
  }
);

export const createDealership = createAsyncThunk<
  any, 
{
  params: string;
  name?:string;
  city?:string;
  phone?:string;
  email?:string;
  website_url?:string;
  supplies_url?:string;
  region_id?:string;
  country_id?:string;
},
{ rejectValue: string; state: RootState}>(
  'dealership/store',
  async (dealership, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await storeDealership(token, dealership);
      return response.data;

    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data.data??error.response.data.message??"An error occurred while creating dealership.");
        } else {
            return rejectWithValue('An error occurred while creating dealership.');
        }
    }
  }
);

export const updateDealership = createAsyncThunk<
    any,
    {
        id: string;
        name?:string;
        city?:string;
        phone?:string;
        email?:string;
        website_url?:string;
        supplies_url?:string;
        region_id?:string;
        country_id?:string;
    },
    { rejectValue: string; state: RootState}>(
    'dealership/update',
    async (dealership, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await updateDealershipApi(token, dealership.id, dealership);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data??error.response.data.message??"An error occurred while updating dealership.");
            } else {
                return rejectWithValue('An error occurred while updating dealership.');
            }
        }
    }
);

export const deleteDealership = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'dealership/delete',
  async (id, {rejectWithValue, getState}) => {
      try {
          const {user} = getState();
          const token = user.accessToken;

          const response = await destroyDealership(token, id);
          return response.data;

      } catch (error: any) {
          if (error.response) {
              return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deleting dealership.");
          } else {
              return rejectWithValue('An error occurred while deleting dealership.');
          }
      }
  }
);

export const assignCorporateUser = createAsyncThunk<
    any,
    {
        id: string;
        user_id:string;
    },
    { rejectValue: string; state: RootState}>(
    'dealership/assign/corporate',
    async (assignInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await assignCorporateUserApi(token, assignInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data??error.response.data.message??"An error occurred while assigning corporate user.");
            } else {
                return rejectWithValue('An error occurred while assigning corporate user.');
            }
        }
    }
);

export const fetchCorporateUsers = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'users/corporate/list',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await getCorporateUsers(token, params);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching corporate users.");
            } else {
                return rejectWithValue('An error occurred while fetching corporate users.');
            }
        }
    }
);
